module.exports = new __parcel__URL__("hu.e94fc771.svg").toString();